import { render } from "./KsAccountManagement.vue?vue&type=template&id=1089bb29&scoped=true"
import script from "./KsAccountManagement.vue?vue&type=script&lang=js"
export * from "./KsAccountManagement.vue?vue&type=script&lang=js"

import "./KsAccountManagement.vue?vue&type=style&index=0&id=1089bb29&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1089bb29"]])

export default __exports__